//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

//store
const PNDJson = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api`,
    state: {
        MensajePNDJSON: ''
    }
}).get({
    action: "get_mensaje", 
    path: function () {
        return `Util/serviciopnd`;
    },  
    onSuccess: (state, payload) => {
        state.MensajePNDJSON = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.MensajePNDJSON = ""
    }
}).put({
    action: "procesarpndjson_",
     path: function () {
        return `/procesarpndjson/serviciopnd`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

PNDJson.getters = {
    gPNDJson: state => {
        return state.MensajePNDJSON;
    }
}

export default PNDJson;